<script>
import { mapState, mapActions } from 'vuex';
/* components */
import Dropdown from '@/components/Dropdown';
/* tools */
import { COUNTRIES } from '@/scripts/constants/countries';
import {
  daysSet,
  monthsSet,
  yearsSet,
  usStates,
} from '@/scripts/constants/map';
import {} from '@/scripts/utils';
import {
  createDate,
  getDateFromUser,
  getDropdownDate,
} from '@/scripts/utils/time';
import { findCountry, findState } from '@/scripts/utils/collection';
import { isEqual } from 'lodash';

export default {
  name: 'UserBio',
  components: {
    Dropdown,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    const { user } = this;

    const date = getDateFromUser(user);
    const dropdown = getDropdownDate(date);
    const { firstName, lastName } = user;
    const country = findCountry(user.country);
    const state = findState(user.state);

    return {
      dropdown,
      date,
      /*  */
      country,
      state,
      firstName,
      lastName,
    };
  },
  watch: {
    payload(next, prev) {
      const updated = !isEqual(next, prev);

      if (updated) this.$emit('change', next);
    },
  },
  computed: {
    ...mapState([]),
    dateOfBirth() {
      const { date } = this;
      const result = createDate(date);

      return result;
    },
    payload() {
      const { dateOfBirth, country, firstName, lastName, state } = this;
      const result = {
        firstName,
        lastName,
        dateOfBirth,
      };

      if (country) result.country = country.title;
      if (state) result.state = state.title;

      return result;
    },
  },
  created() {
    /*  */
    this.COUNTRIES = COUNTRIES;
    this.days = daysSet;
    this.months = monthsSet;
    this.years = yearsSet;
    this.usStates = usStates;
  },
  mounted() {},
  methods: {
    ...mapActions({}),
    changeCounrty(country) {
      this.country = country;
    },
    changeUsState(state) {
      this.state = state;
    },
    setDate(val, field) {
      this.$set(this.dropdown, field, val);
      this.$set(this.date, field, val.value);
    },
  },
};
</script>

<template>
  <div class="form">
    <!-- DOB -->
    <div class="form__row z-3">
      <div class="input-block">
        <div class="input-block__label">DOB</div>
        <div class="input-block__wrapper input-block__wrapper--flex">
          <div class="input-block__item input-block__item--sm z-3">
            <Dropdown
              :items="days"
              :placeholder="'Day'"
              :style-type="'form'"
              :forceValue="dropdown.days"
              @change="val => setDate(val, 'days')"
            ></Dropdown>
          </div>
          <div class="input-block__item input-block__item--md z-3">
            <Dropdown
              :items="months"
              :placeholder="'Month'"
              :style-type="'form'"
              :forceValue="dropdown.months"
              @change="val => setDate(val, 'months')"
            ></Dropdown>
          </div>
          <div class="input-block__item input-block__item--lg">
            <Dropdown
              :items="years"
              :placeholder="'Year'"
              :style-type="'form'"
              :forceValue="dropdown.years"
              @change="val => setDate(val, 'years')"
            ></Dropdown>
          </div>
        </div>
      </div>
    </div>
    <!-- // -->

    <!-- country -->
    <div class="form__row z-2">
      <div class="input-block">
        <div class="input-block__label">Country</div>
        <div class="input-block__wrapper">
          <Dropdown
            :items="COUNTRIES"
            :forceValue="country"
            :placeholder="'Choose your country'"
            :type="'country'"
            :style-type="'form'"
            @change="changeCounrty"
          />
        </div>
      </div>
    </div>
    <!-- // -->

    <!-- Select state -->
    <div v-if="country && country.value === 'US'" class="form__row z-1">
      <div class="input-block">
        <div class="input-block__label">State</div>
        <div class="input-block__wrapper">
          <Dropdown
            :forceValue="state"
            :item-text="'text'"
            :items="usStates"
            :message="'Select state'"
            :style-type="'form'"
            @change="changeUsState"
          ></Dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.form {
  width: 100%;

  &__row {
    width: 100%;

    & + & {
      margin-top: 30px;
    }
  }

  .z-1 {
    position: relative;
    z-index: 1;
  }
  .z-2 {
    position: relative;
    z-index: 2;
  }
  .z-3 {
    position: relative;
    z-index: 3;
  }
}

.input-block {
  width: 100%;
  position: relative;

  &__label {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.7);
  }

  &__wrapper {
    width: 100%;
    margin-top: 15px;
    position: relative;

    &--flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__item {
    width: 100%;
    &--sm {
      max-width: 140px;
    }
    &--md {
      max-width: 180px;
    }
    &--lg {
      max-width: 210px;
    }

    & + & {
      margin-left: 20px;
    }
  }

  .z-3 {
    position: relative;
    z-index: 3;
  }
}

@media (max-width: $mobile) {
  .input-block {
    &__label {
      font-size: 12px;
      line-height: 17px;
    }

    &__wrapper--flex {
      flex-wrap: wrap;
    }

    &__item {
      width: auto;
      flex-grow: 1;

      &--sm {
        max-width: none;
        min-width: 120px;
        margin-right: 10px;
      }

      &--md {
        max-width: none;
        min-width: 160px;
      }

      &--lg {
        max-width: none;
        min-width: 100%;
        margin-top: 15px;
      }

      & + & {
        margin-left: 0;
      }
    }
  }
}
</style>
